<div id="exo-information" class="row information-container test-main">
  <div class="row">
    <div class="left">
      <h2 class="center grey darken-1 white-text title-information">Create Exercise</h2>
    </div>
  </div>
  <div class="row information-subcontainer" [formGroup]="exerciceFormGroup">

   <div class="col l12">
        <span class="flexchild nogrow">Title: </span>
      <input class="flexchild title-input" name="title" type="text"  formControlName="title" />
      <mat-error *ngIf="exerciceFormGroup.controls.title.touched && exerciceFormGroup.controls.title.hasError('required')">This field is required</mat-error>
    </div>

   <div class="col l12 flexparent centeralign">
      <span class="flexchild nogrow exo-info-difficulty">Difficulty: </span>
      <mat-radio-group [color]="'primary'" class="flexchild"  formControlName="difficulty">
            <mat-radio-button *ngFor="let difficulty of difficultyList" [value]="difficulty.data">
              <span  class ="radio-button-label">{{ difficulty.label }}</span>
            </mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="exerciceFormGroup.controls.difficulty.touched && exerciceFormGroup.controls.difficulty.hasError('required')">This field is required</mat-error>
    </div>

    <div class="col l12 flexparent centeralign">
      <span class="flexchild nogrow exo-info-difficulty">Category: </span>
      <mat-radio-group [color]="'primary'" class="flexchild"  formControlName="category">
            <mat-radio-button *ngFor="let category of categoryList" [value]="category.url">
              <span  class ="radio-button-label">{{ category.name }}</span>
            </mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="exerciceFormGroup.controls.category.touched && exerciceFormGroup.controls.category.hasError('required')">This field is required</mat-error>
    </div>

    <div class="col l12">
      <span class="flexchild nogrow">Duration: </span>
      <select class="flexchild duration-select" name="duration" formControlName="duration">
        <option *ngFor="let duration of [5, 10, 15, 20, 30]" [value]="duration">{{ duration }} min</option>
      </select>
      <mat-error *ngIf="exerciceFormGroup.controls.duration.touched && exerciceFormGroup.controls.duration.hasError('required')">This field is required</mat-error>
    </div>

    <div class="col l12">
      <span class="flexchild nogrow">Instructions: </span>
      <textarea class="flexchild instructions-input" name="instructions" formControlName="instructions" rows="5"></textarea>
      <mat-error *ngIf="exerciceFormGroup.controls.instructions.touched && exerciceFormGroup.controls.instructions.hasError('required')">This field is required</mat-error>
    </div>

    <div class="col l12">
      <span class="flexchild nogrow">Attachment: </span>
      <input class="flexchild" type="file" (change)="storeFiles($event)" />
    </div>

    <div class="center">
        <button class="creatraining-btn action-button" (click)="createExercice()" [disabled]="!exerciceFormGroup.valid">
          Create an exercise
        </button>
    </div>
  </div>
</div>
